import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase/clients';

export interface CallableInvoker {
  invoke<TRequest, TResult>(name: string, request: TRequest): Promise<TResult>;
}

export const callableClient: CallableInvoker = {
  async invoke<TRequest, TResult>(name: string, request: TRequest): Promise<TResult> {
    const callable = httpsCallable<TRequest, TResult>(functions, name);
    const result = await callable(request);
    return result.data;
  },
};
